import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ConfirmModal } from "./ConfirmModal";

export function OrderCardModal() {
  const { t } = useTranslation();

  const searchForm = useSelector((state: any) => state.card.params);
  const cardTypes = useSelector((state: any) => state.cardTypes.cardTypes);

  const cardTypeName = cardTypes.find(
    (x: any) => x.id === searchForm.cardTypeId
  ).name;

  const contentProps = {
    title: t("searchCard.menu.orderCard"),
    description: ` Vill patienten ${searchForm.personId} beställa nytt frikort för frikortstypen  ${cardTypeName}  och få det hemskickat?`,
  };

  return <ConfirmModal {...contentProps} />;
}
